//r-18-lint-bk
//eslint-disable-next-line
export default () => {
    self.addEventListener("message", e => { // eslint-disable-line no-restricted-globals
        if (!e) return
        if (e.data.action === "updateHRRState") {
            self.postMessage(e.data.payload)// eslint-disable-line no-restricted-globals
        }
    })
}